import { render } from "./ProfileInfo.vue?vue&type=template&id=b08a26b6&scoped=true"
import script from "./ProfileInfo.vue?vue&type=script&lang=js"
export * from "./ProfileInfo.vue?vue&type=script&lang=js"

import "./ProfileInfo.vue?vue&type=style&index=0&id=b08a26b6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b08a26b6"]])

export default __exports__